const KanBanHeader = ({ pipelineName }: { pipelineName?: string }) => {
  if (!pipelineName) return null;

  return (
    <div className="flex items-center px-[20px] py-[8px] shrink-0 rounded-t-[6px] bg-[#6674881A]">
      <p className="text-sm font-semibold text-verba-indigo dark:text-verba-indigo-dk">
        {pipelineName.toUpperCase()}
      </p>
    </div>
  );
};

export default KanBanHeader;
